import { render, staticRenderFns } from "./SearchResultItemMedia.vue?vue&type=template&id=00b370ed&scoped=true&"
import script from "./SearchResultItemMedia.vue?vue&type=script&lang=ts&"
export * from "./SearchResultItemMedia.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultItemMedia.vue?vue&type=style&index=0&id=00b370ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b370ed",
  null
  
)

export default component.exports